<section class="title-bar content-padding first-item content-padding">
    <div class="wrapper">
        <h2 class="left">{{ provinceId ? "Modifica" : "Nuovo" }} Cities of Province</h2>
        <br class="clear">
    </div>
</section>

<section class="content-padding darker">
  <div class="narrow-wrapper">
    <form class="has-cols" [formGroup]="provinceCitiesForm" (ngSubmit)="onSubmit()">
      <div class="basic-info-box" style="margin-top: 15px;">
        <fieldset>
            <legend>Province & Cities:</legend>

            <div class="grid-element-full">
                <label for="category">Province{{ provinceCitiesForm.get("province") | required }}</label>
                <ng-select
                    class="province"
                    [multiple]="false" 
                    [hideSelected]="true"
                    [closeOnSelect]="true"
                    formControlName="province"
                    [attr.disabled]="true"
                >
                <ng-option *ngFor="let province of provinces" [value]="province.id"><b>{{ province?.provinceCode }}</b> {{ province?.province }}</ng-option>
                </ng-select>
                <app-error-html-handler [ctrl]="provinceCitiesForm.get('province')" [messages]="formValidationMsgs.province"></app-error-html-handler>
            </div>
            <br class="clear">

            <div class="grid-element-full">
                <fieldset>
                    <legend>Cities</legend>
                    <div formArrayName="cities">
                        <div class="offer-products" *ngFor="let cities of provinceCitiesForm.get('cities').controls; let i = index">
                            <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                                <label for=""></label>
                                <div style="display: table-cell; width: 19px;">
                                    <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProvinceCity(i)"></i>
                                </div>
                            <div class="product-q">
                                <div class="porduct-qty">
                                    <div class="province-input">
                                        <label for=""></label>
                                        <div class="grid-element-full">
                                            <app-google-map-cities formControlName="cityName" (setAddress)="getCityName($event, i)" [control]="cities.get('cityName')"></app-google-map-cities>
                                            <app-error-html-handler [ctrl]="cities.get('cityName')" [messages]="formValidationMsgs.cities.cityName"></app-error-html-handler>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            </div>
                        </div>
                    </div>
                    <div class="center" style="width: 100%;">
                        <button class="btn mt-5" (click)="$event.preventDefault(); addProvinceCity()">
                            Aggiungi City<i class="ml-10 fas fa-plus"></i>
                        </button>
                    </div>
                </fieldset>
            </div>
        </fieldset>
      </div>

      <div class="center" style="margin-top: 10px;">
        <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!provinceCitiesForm.valid">
          Salva<i class="ml-10 far fa-save"></i>
        </button>
      </div>
      
    </form>
    <br class="clear">
  </div>
</section>